
define(
	'ThemeOverrides'
,   [
		'Handlebars'
	]
,   function (
		Handlebars
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp ()
		{
			Handlebars.registerHelper('formatNumber', function (number) {
				return (number || 0).toLocaleString('en-US');
			});

			Handlebars.registerHelper('isEqual', function (a, b) {
				return a === b;
			});

			Handlebars.registerHelper('nonReturnableReason', function (status) {
				if (!status || status === 'Yes') return '';
				var parts = status.split('-');
				return parts.length > 1 ? parts[1].trim() : '';
			});
		}
		
	};
});
